import React, { useState, useEffect } from 'react';
import { Faqs } from '../../pages';
import { toJS } from 'mobx';
import { SupportController } from '../../controllers';
import { supportStore } from '../../stores';


const FaqsContainer = () => {
    const [loading, setLoading] = useState(false);
    const [addFaqModal, setAddFaqModal] = useState(false);
    const [editFaqModal, setEditFaqModal] = useState(false);
    const [deleteFaqModal, setDeleteFaqModal] = useState(false);

    useEffect(() => {
        setLoading(true)
        const getFaqDetails = async () => {
            await SupportController.getFaqs();
            setLoading(false);
        }
        getFaqDetails();
    }, [])

    const goToAddFaqModal = () => {
        setAddFaqModal(true);
    }
    const goToEditFaqModal = () => {
        setEditFaqModal(true);
    }
    const goToDeleteFaqModal = () => {
        setDeleteFaqModal(true);
    }

    const closeModal = () => {
        setAddFaqModal(false);
        setEditFaqModal(false);
        setDeleteFaqModal(false);
    }

    return (
        <Faqs
            goToDeleteFaqModal={goToDeleteFaqModal}
            deleteFaqModal={deleteFaqModal}
            goToAddFaqModal={goToAddFaqModal}
            addFaqModal={addFaqModal}
            goToEditFaqModal={goToEditFaqModal}
            editFaqModal={editFaqModal}
            loading={loading}
            closeModal={closeModal}    
            faqs={toJS(supportStore.faqs)}        
        />
    )
}
export default FaqsContainer;